<template>
  <section class="card">
    <header class="card-header">
      <div class="card-actions">
        <a href="#" class="card-action card-action-toggle" data-card-toggle></a>
      </div>

      <h2 class="card-title">{{$root.subTitle}}</h2>
    </header>
    <div class="card-body">
      <table class="table table-bordered table-striped mb-none">
        <thead>
          <tr>
            <th>名稱</th>
            <th>建立時間</th>
            <th class="actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in rows" :key="item.id">
            <td>{{item.title}}</td>
            <td>{{item.createTime|dateTime}}</td>
            <td class="actions">
              <router-link :to="{name:'/forms/values/:layoutId', params:{layoutId:item.id}}" class="on-default edit-row">
                <i class="fas fa-database"></i>
              </router-link>
              <router-link :to="{name:'/forms/edit/:id', params:{id:item.id}}" class="on-default edit-row">
                <i class="fas fa-pencil-alt"></i>
              </router-link>
              <a class="on-default remove-row" @click="remove(item.id, i)">
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import { forms } from "@/resource";

export default {
  data() {
    return {
      rows: []
    };
  },
  mounted() {
    this.load().then(this.init);
  },
  methods: {
    init() {
      this.table = $(".table").dataTable({
        aoColumns: [
          ...new Array($("table th").length - 1),
          {
            bSortable: false
          }
        ]
      });
    },
    load() {
      return new Promise(resolve => {
        forms.history({ id: this.$route.params.id }).then(a => {
          this.rows = a.body;
          resolve();
        });
      });
    },
    remove(id, i) {
      if (!confirm("確定要刪除嗎？")) return;
      forms
        .delete({
          id: id
        })
        .then(a => {
          this.rows.splice(i, 1);
          this.table.fnDeleteRow(i);
        });
    }
  }
};
</script>
